<template>
  <v-container
    fill-height
    class="text-center d-flex flex-column justify-center align-center"
  >
    <!-- Imagen del mono estilo YouTube -->
    <v-img
      src="https://www.gstatic.com/youtube/src/web/htdocs/img/monkey.png"
      max-width="300"
      class="mb-6"
      contain
    />

    <h1 class="display-2 font-weight-bold">404</h1>
    <h2 class="subtitle-1 mb-4">Esta página no existe o fue eliminada.</h2>
    <v-btn color="primary" @click="$router.push('/admin')">
      Volver al inicio
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
